import styled from '@emotion/styled';

export const Container = styled('div')`
  width: 100%;
  max-width: 39rem;
  margin: auto;
  text-align: center;
`;

export const Icon = styled('img')`
  width: 12.1rem;
  height: 6rem;
  margin-bottom: 2rem;
`;
